import { MenuList, type TypographyProps } from '@mui/material'
import { Dialog } from '@tunasong/ui-lib'
import { type FC } from 'react'
import { ToolsMenuItems } from './tools-menu-items.js'

export interface ToolsDialogProps {
  open: boolean
  variant?: TypographyProps['variant']
  onClose: () => void
}

export const ToolsDialog: FC<ToolsDialogProps> = props => {
  const { variant } = props
  return (
    <Dialog fullScreen fullWidth title="Tools" {...props}>
      <MenuList>
        <ToolsMenuItems variant={variant} onClose={props.onClose} />
      </MenuList>
    </Dialog>
  )
}

export default ToolsDialog
